import type { RouteRecordRaw } from 'vue-router';

import publicRoutes from './public';
import { routes as adminAccesControlRoutes } from '@precon-tools-suite-by-shared/admin-access-control-feature';
import { routes as adminCompaniesRoutes } from '@precon-tools-suite-by-shared/admin-companies-feature';
import { routes as adminMaintenanceRoutes } from '@precon-tools-suite-by-shared/admin-maintenance-feature';

export default [
    ...publicRoutes,
    ...adminAccesControlRoutes,
    ...adminCompaniesRoutes,
    ...adminMaintenanceRoutes,
] as RouteRecordRaw[];
